import { ContactForm } from "./ContactForm";
import { ContactSectionContainer } from "./styles.styled";

export const ContactSection = () => {
  return (
    <ContactSectionContainer>
      <ContactForm />
    </ContactSectionContainer>
  );
};
